import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, toImg } from "@/api/client";
import { MapPin, TrendingUp } from "lucide-react";

const fmtEur = (n) => new Intl.NumberFormat("pt-PT", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(n);

export default function ZonasPage() {
  const [zones, setZones] = useState([]);
  useEffect(() => {
    api.get("/zones").then((r) => setZones(r.data)).catch(() => {});
  }, []);

  return (
    <div data-testid="page-zonas">
      <section className="container-cnp pt-14 lg:pt-20 pb-8">
        <div className="max-w-3xl">
          <span className="tag-chip">Zonas</span>
          <h1 className="mt-6 font-display text-4xl sm:text-5xl lg:text-6xl text-stone-900 leading-[1.05]">
            Porto e Grande Porto,<br/><span className="italic text-[#103C4A]">rua a rua.</span>
          </h1>
          <p className="mt-6 text-lg text-stone-600 leading-relaxed">
            Cada zona tem a sua identidade, mercado e perfil de comprador. Aqui reúno o essencial para o ajudar
            a escolher onde comprar ou onde vender.
          </p>
        </div>
      </section>

      <section className="container-cnp py-12 grid md:grid-cols-2 gap-6">
        {zones.map((z) => (
          <Link key={z.id} to={`/zonas/${z.slug}`} data-testid={`zonas-list-${z.slug}`} className="group relative overflow-hidden rounded-3xl block aspect-[16/10]">
            <img src={toImg(z.main_image)} alt={`${z.name} — vista da zona`} loading="lazy" className="absolute inset-0 h-full w-full object-cover transition-transform duration-[900ms] group-hover:scale-105" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />
            {z.avg_price_sqm ? (
              <div className="absolute top-5 right-5 rounded-full bg-white/95 backdrop-blur px-4 py-2 text-[#103C4A] shadow-lg" data-testid={`zonas-price-${z.slug}`}>
                <div className="text-[9px] uppercase tracking-[0.2em] text-stone-500">Preço médio</div>
                <div className="text-base font-semibold leading-tight">{fmtEur(z.avg_price_sqm)}<span className="text-[11px] font-normal text-stone-500"> / m²</span></div>
              </div>
            ) : null}
            <div className="absolute inset-x-0 bottom-0 p-8 text-white">
              <div className="flex items-center gap-1.5 text-xs uppercase tracking-widest opacity-80"><MapPin className="h-3.5 w-3.5" /> Grande Porto</div>
              <div className="mt-2 font-display text-3xl md:text-4xl">{z.name}</div>
              <p className="mt-2 max-w-md opacity-85">{z.short_intro}</p>
              <div className="mt-4 inline-flex items-center text-sm">Conhecer a zona →</div>
            </div>
          </Link>
        ))}
      </section>

      {zones.some((z) => z.avg_price_sqm) && (
        <section className="container-cnp pb-24">
          <div className="rounded-3xl border border-stone-200 bg-white p-8 md:p-10">
            <div className="flex items-baseline justify-between gap-6 mb-6">
              <div>
                <div className="text-[10px] uppercase tracking-[0.24em] text-stone-500">Mercado</div>
                <h2 className="mt-2 font-display text-3xl md:text-4xl text-stone-900 tracking-[-0.02em]">Preço médio no Grande Porto</h2>
                <p className="mt-2 text-stone-600 text-sm">Referência de €/m² para apartamentos à venda. Valores actualizados a partir de índices públicos.</p>
              </div>
              <TrendingUp className="hidden md:block h-8 w-8 text-[#103C4A] shrink-0" />
            </div>
            <div className="rule-hair mb-4" />
            <div className="grid grid-cols-2 md:grid-cols-5 gap-6" data-testid="zones-market-summary">
              {zones.filter((z) => z.avg_price_sqm).map((z) => (
                <Link key={z.id} to={`/zonas/${z.slug}`} className="group">
                  <div className="text-[10px] uppercase tracking-[0.22em] text-stone-500">{z.name}</div>
                  <div className="mt-1 font-display text-2xl md:text-3xl text-[#103C4A] group-hover:text-[#0B2B36] transition-colors">{fmtEur(z.avg_price_sqm)}</div>
                  <div className="text-[11px] text-stone-500">por m² · {z.avg_price_sqm_updated || "actual"}</div>
                </Link>
              ))}
            </div>
          </div>
        </section>
      )}
    </div>
  );
}
